import React, {useEffect, useState} from 'react';
import * as s from './adminStyles';

const API_BASE = '/api';
export default function SiteGate({children}) {
    const [status, setStatus] = useState('checking')
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        fetch(`${API_BASE}/check.php`, {credentials: 'include'})
            .then((res) => res.json())
            .then((data) => setStatus(data.authed ? 'in' : 'out'))
            .catch(() => setStatus('out'));
    }, []);

    const submit = async (e) => {
        e.preventDefault();
        setError('');
        try {
            const res = await fetch(`${API_BASE}/login.php`, {
                method: 'POST',
                credentials: 'include',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({username: username, password: password}),
            });
            const data = await res.json().catch(() => ({}));
            if (res.ok && data.ok) {
                setStatus('in');
            } else {
                setError(data.error || 'Falsches Passwort.');
            }
        } catch {
            setError('Server nicht erreichbar.');
        }
    };

    if (status === 'checking') {
        return <div style={{width: '100vw', height: '100vh', background: '#ffffff'}}/>;
    }

    if (status === 'in') return children;

    return (
        <div style={s.page}>
            <form onSubmit={submit} style={{maxWidth: '340px', margin: '30vh auto 0', padding: '0 24px'}}>
                <h1 style={{...s.h1, fontSize: '22px', marginBottom: '16px'}}>Login</h1>
                <input
                    type="text"
                    autoFocus
                    placeholder="username"
                    value={username}
                    onChange={(e) => {
                        setUsername(e.target.value);
                        setError('');
                    }}
                    style={s.input2}
                />
                <input
                    type="password"
                    placeholder="passwort"
                    value={password}
                    onChange={(e) => {
                        setPassword(e.target.value);
                        setError('');
                    }}
                    style={s.input}
                />

                {error && <p style={{...s.hint, color: '#c0392b'}}>{error}</p>}
                <button type="submit" style={{...s.primaryButton, marginTop: '16px'}}>
                    Anmelden
                </button>
            </form>
        </div>
    );
}
